import React, { useEffect, useState } from 'react'
import slides from './hero.data'
import { heroStyle as styles } from './hero.tailwind'
import Button from '../../shared/Button/Button'
import rightArrow from '../../../assets/svgs/right_arrow.svg'
import { useNavigate } from 'react-router-dom'
import routeConstant from '../../../lib/constants/routeConstant'
import { storage } from '../../../config/storage'
import { useSelector } from 'react-redux'

const Hero = () => {
  const navigate = useNavigate()
  const { isSignedIn } = useSelector((state) => state.user)
  const [slideIndex, setSlideIndex] = useState(0);

  const handleExploreTokens = () => {
    if(!isSignedIn){
      // set to local-storage to navigate on this page if not loginned
      storage.setInLocalStorage.navigateOnLogin(routeConstant.SELECT_SPORT_PAGE);
    }
    navigate(routeConstant.SELECT_SPORT_PAGE)
  }

  useEffect(() => {
    // Setting interval to change slide every 2000ms (2s)
    let interval = window.setInterval(() => {
      try {
        setSlideIndex((index) => (
          index < slides.length - 1 ? index + 1 : 0
        ));
      } catch (error) {
        console.log(error)
      }
    }, 2000);

    return () => {
      // Cleaning up
      clearInterval(interval);
    }
  }, [])

  //FOR DEMO CHANGED THE LINE
  return (
    <section className={styles.hero_wrapper}>
      {/* main slide image */}
      <div className={styles.slide_wrpr}>
        <figure className={styles.slide_image_wrpr}>
          <img src={slides[slideIndex]?.image} alt="hero" className="w-full h-full object-cover object-top" />
          {/* Overlay */}
          <div className={styles.overlay_image} />
        </figure>

        {/* slide navigation dots */}
        <div className={styles.slides_navigation}>
          {/* slide dots */}
          {slides.map((_, key) => (
            <div key={key} className={`${styles.dot} ${slideIndex === key ? 'before:opacity-100' : 'before:opacity-0'}`} />
          ))}
        </div>

        {/* Textual data */}
        <div className={styles.text_wrpr}>
          {/* <h1 className={styles.heading}><span className={styles.shaded_heading}>Own a Piece</span> of the Game, Be Part <span className={styles.shaded_heading}>of Every Moment</span></h1> */
          <h1 className={styles.heading}>experience<span className={styles.shaded_heading}> College Football</span>  like never before<span className={styles.shaded_heading}></span></h1>}
          <p className={styles.description}>Get your token, earn rewards, and experience the thrill of sports like never before.</p>
        </div>

        {/* Explore Button */}
        <Button variant='primary' className={styles.explore_btn} onClick={handleExploreTokens}>
          Explore Tokens
          <span className={styles.arrow_wrpr}>
            <img src={rightArrow} alt="" className={styles.arrow} />
          </span>
        </Button>
      </div>
    </section>
  )
}

export default Hero